import axios from 'axios'
import {ResponseObjectUpload} from '../../../../../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function uploadTemplateService(test: any, bulkLoadId?: string) {
  return axios.post<ResponseObjectUpload>(`${BASEURL}/bed/bulkLoad?bulkLoadId=${bulkLoadId}`, test, {
      timeout: 240000,
    },)
}